import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a177ea90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "messageBannerApp" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "warning" }
const _hoisted_5 = { class: "messageBannerText" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  role: "img",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "\n  M9.97056 11.3849\n  L17.7487 19.1631\n  L19.163 17.7489\n  L11.3848 9.9707\n  L19.163 2.19253\n  L17.7487 0.778315\n  L9.97056 8.55649\n  L2.19239 0.778315\n  L0.778174 2.19253\n  L8.55635 9.9707\n  L0.778174 17.7489\n  L2.19239 19.1631\n  L9.97056 11.3849\n  Z"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { Icon } from '../Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimezoneWarning',
  emits: ['close'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Icon), { "icon-name": "messageBannerAlert" })
          ])
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('UK dates message')), 1),
        _createElementVNode("button", {
          "aria-label": "close message banner",
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_7)
      ])
    ])
  ]))
}
}

})